import APIService from "@quest-finance/quest-fe-shared/dist/common/services/APIService";
import { ListResponse } from "@quest-finance/quest-fe-shared/dist/common/types/ListResponse";
import { SingleResponse } from "@quest-finance/quest-fe-shared/dist/common/types/SingleResponse";
import { convertToQueryParams } from "@quest-finance/quest-fe-shared/dist/common/utils/object";
import { Method } from "axios";
import { InternalNotesListRequest } from "../../common/internal-notes/types/InternalNotesListRequest";
import { InternalNotesResponse } from "../../common/internal-notes/types/InternalNotesResponse";
import { InternalNotesSubmitRequest } from "../../common/internal-notes/types/InternalNotesSubmitRequest";

class InternalNotesService {
  public static async getInternalNotes(
    assessmentId: string,
    payload: InternalNotesListRequest
  ): Promise<ListResponse<InternalNotesResponse>> {
    const queryParams = convertToQueryParams(payload);
    const method: Method = "GET";
    const path = `/assessment/assessments/${assessmentId}/notes${queryParams}`;

    const result = await APIService.jsonRequest<
      ListResponse<InternalNotesResponse>,
      unknown
    >(
      {
        method,
        path,
      },
      true
    );
    return result;
  }
  public static async submitInternalNotes(
    assessmentId: string,
    data: InternalNotesSubmitRequest
  ): Promise<SingleResponse<InternalNotesResponse>> {
    const result = await APIService.jsonRequest<
      SingleResponse<InternalNotesResponse>,
      InternalNotesSubmitRequest
    >(
      {
        method: "POST",
        path: `/assessment/assessments/${assessmentId}/notes`,
        data,
      },
      true
    );
    return result;
  }
}

export default InternalNotesService;
